<template>
    <v-simple-table dense>
        <template v-slot:default>
            <thead>
            <tr>
                <th class="text-left">{{ $t('components.components_table.component') }}</th>
                <th class="text-left">{{ $t('components.components_table.color') }}</th>
                <th class="text-left">{{ $t('components.components_table.weight') }} [kg]</th>
                <th class="text-left">{{ $t('components.components_table.width') }} [cm]</th>
                <th class="text-left">{{ $t('components.components_table.height') }} [cm]</th>
                <th class="text-left">{{ $t('components.components_table.depth') }} [cm]</th>
                <th class="text-left" style="width: 160px;">{{ $t('components.components_table.availability') }}</th>
                <th class="text-left" style="width: 160px;">{{ $t('components.components_table.date_of_supply') }}</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="unit in units"
                :key="'unit-'+unit.UnitID"
            >
                <td>{{ unit.Component.ComponentName }}</td>
                <td>{{ unit.UnitColor.UnitColorName }}</td>
                <td>{{ unit.UnitDetail.Weight }}</td>
                <td>{{ unit.UnitDetail.Width }}</td>
                <td>{{ unit.UnitDetail.Height }}</td>
                <td>{{ unit.UnitDetail.Depth }}</td>

                <td v-if="unit.State">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <div v-bind="attrs" v-on="on">
                                <icon-quantity-empty v-if="unit.State.StateID === 0"></icon-quantity-empty>
                                <icon-quantity-low v-else-if="unit.State.StateID === 1"></icon-quantity-low>
                                <icon-quantity-medium v-else-if="unit.State.StateID === 2"></icon-quantity-medium>
                                <icon-quantity-hi v-else-if="unit.State.StateID === 3"></icon-quantity-hi>
                            </div>
                        </template>
                        <span>{{ unit.State.StateName }}</span>
                    </v-tooltip>
                </td>
                <td v-else>{{ $t('components.components_table.no_data') }}</td>

                <td v-if="unit.State && unit.State.StateID && unit.AvailableAt">{{ unit.AvailableAt | dateFormat}}</td>
                <td v-else-if="unit.State && unit.State.StateID">?</td>
                <td v-else>-</td>
            </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
import IconQuantityHi from "./IconQuantityHi";
import IconQuantityMedium from "./IconQuantityMedium";
import IconQuantityLow from "./IconQuantityLow";
import IconQuantityEmpty from "./IconQuantityEmpty";

export default {
    name: "ComponentsTable",

    components: {
        IconQuantityHi,
        IconQuantityMedium,
        IconQuantityLow,
        IconQuantityEmpty
    },

    props: {
        units: Array,
    },
}
</script>

<style scoped>

</style>
